// extracted by mini-css-extract-plugin
module.exports = {"home":"Home_home__31ZEC","nameInput":"Home_nameInput__1awWf"};